import React from 'react'
import styled from 'styled-components'
import { darken } from 'polished'

const Container = styled.div`
  background-color: ${props => props.theme.colors.green};
  width: 40px;
  height: 40px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: ${props => darken(0.05, props.theme.colors.green)};
  }

  @media (min-width: 768px) {
    display: ${props => props.hideOnDesktop ? 'none' : 'flex'};
  }
`

const Icon = styled.div`
  fill: ${props => props.theme.colors.white};
  height: 20px;
  width: 20px;
`

export default ({ icon, href, hideOnDesktop, ...rest }) => (
  <Container as={href ? 'a' : 'div'} hideOnDesktop={hideOnDesktop} href={href} target='_top'>
    <Icon as={icon} {...rest} />
  </Container>
)
